<template>
    <div>
        <PageTitle
            title="INSCRIPCIÓN A CANTERA"
            class="stretch"
        ></PageTitle>
        <section class="padding-vertical-content pt-3 right-background">
            <div class="thumb-container absolute grayscale light-thumb" :style='"background-image: url(" + footer.imagen_info_bases_url + ");"'></div>
            <div class="container">
                <b-row>
                    <b-col cols="12">
                        <div class="row justify-content-start">
                            <div class="col-12 col-lg-6 pb-0">
                                <h2 class="m-0 mt-5 h1 text-uppercase">Información</h2>
                                <div class="subtitle h5 light mb-3 mb-lg-5" v-html="footer.informacion_base"></div>
                            </div>
                        </div>    
                    </b-col>
                    <b-col sm="12" xl="6" v-if="!codigo_correcto && footer.activar_compra_por_invitacion_bases">
                        <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                            <b-container>
                                <b-row>
                                    <b-col cols="12">
                                        <FormInput label="Introduce el código de invitación para continuar la compra" id="codigo_invitacion" name="codigo de invitación" rules="required" v-model="codigo_invitacion" />
                                        <div v-if="error" class="p-2 mb-2 bg-danger text-white">
                                            <b>{{ error }}</b>
                                        </div>
                                        <p><b>{{ $t('formularios.codigo_invitacion') }}</b></p>
                                    </b-col>
                                    <b-col cols="12">
                                        <div class="mt-2">
                                            <button id="go-to-compra" type="submit" name="button" class="button effect-button large-button" :disabled="!codigo_invitacion">
                                                <span>{{ $t('formularios.continuar') }}</span>
                                            </button>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-container>
                        </ValidationObserver>
                    </b-col>
                    <div v-else class="ml-5 pl-4">
                        <router-link :to="{ name: 'front.bases.crear' }" id="nueva-alta" class="button large-button effect-button sitecolor-content mr-2 mb-2" style="padding: 22px;"><span>Nueva alta</span></router-link>
                        <router-link v-if="!footer.ocultar_renovacion_futbol_base" :disabled="!footer.renovacion_futbol_base" :to="{ name: 'front.bases.renovar' }" class="button large-button effect-button sitecolor-content mr-2 mb-2" style="padding: 22px;"><span>Renovar</span></router-link>
                    </div>
                </b-row>
            </div>
        </section>  
    </div>
</template>

<script>
import PageTitle from "@/components/frontend/shared/PageTitle";

export default {
    data() {
        return {
            error: null,
            codigo_correcto: false,
            codigo_invitacion: null
        }
    },
    methods: {
        validarCodigo() {
            this.loading = true;

            var params = {
                filters : {},
                teatro_id: this.teatro.id,
                lista_id: this.lista_abonados.id,
                codigo_invitacion: this.codigo_invitacion
            }

            this.$store.dispatch(this.config.getVuexAlias('front.bases.validar_codigo'), params).then(res => {
                this.$toast.success(res.data.message);
                this.error = null;
                this.codigo_correcto = true;
                localStorage.setItem('codigo_invitacion', this.codigo_invitacion)
            }).catch(error => {
                this.error = error.response.data.message;
            }).finally(() => this.loading = false);
        },
        async submit() {
            const isValid = await this.$refs.observer.validate();
            if(isValid) {
                this.validarCodigo();
            }
        },
    },
    computed: {
        footer() {
            return this.$store.getters.getFooter;
        },
        lista_abonados() {
            return this.$store.getters.getListaAbonados;
        },
        teatro() {
            return this.$store.getters.getTeatro;
        }
    },
    components: { PageTitle }
}
</script>